// extracted by mini-css-extract-plugin
module.exports = {"frame":"_2YGy3lFIYdUZ5omMYWKv8n"};